// TODO: Implement search products

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SearchProductsStore {
  keyword: string
  setKeyword: (keyword: string) => void
}

export const useSearchProductsStore = create<SearchProductsStore>()(
  persist(
    (set) => ({
      keyword: '',
      setKeyword: (keyword: string) => set({ keyword }),
    }),
    {
      name: 'keyword-search-storage',
    }
  )
)
